var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect } from "react";
import TopCurvedGenericTabs from "@frameworks/shared-library/components/TopCurvedGenericTabs/TopCurvedGenericTabs";
import "@frameworks/salesjourney/stylesheets/components/Features/ActivityBook/RM_Orderbook/RM_Orderbook.scss";
import AccountOpening from "./AOP Orderbook";
import { checkIfMFIsAccessible } from "@frameworks/salesjourney/utils/genericMethods";
import ProductOrders from "./ProductOrders";
import { generatePageHeaderName } from "@frameworks/salesjourney/components/Generic/TransparentHeader/TransparentHeader";
export var getExpandedLabelForL1Category = {
    Wealth: "Wealth Products",
    NonWealth: "Non Wealth Products",
};
export var EOrderbookTabKeys;
(function (EOrderbookTabKeys) {
    EOrderbookTabKeys["PRODUCT_ORDERS"] = "1";
    EOrderbookTabKeys["ACCOUNT_OPENING"] = "2";
})(EOrderbookTabKeys || (EOrderbookTabKeys = {}));
var RMOrderbook = function (props) {
    // *******************************************
    // *           useStates                     *
    // *******************************************
    var _a = __read(React.useState([]), 2), orderbookTabs = _a[0], seOrderbookTabs = _a[1];
    // *******************************************
    // *           constants                     *
    // *******************************************
    var topLevelTabs = [
        {
            title: React.createElement("span", { className: "DMSanN_16_400" }, "Product Orders"),
            eventKey: EOrderbookTabKeys.PRODUCT_ORDERS,
            tabContent: React.createElement(ProductOrders, null),
        },
        {
            title: React.createElement("span", { className: "DMSanN_16_400" }, "Account Opening"),
            eventKey: EOrderbookTabKeys.ACCOUNT_OPENING,
            tabContent: (React.createElement("div", { className: "d-flex align-items-center bg-ghost-white2 tabs-container-acitivity-book" },
                React.createElement(AccountOpening, null))),
        },
    ];
    // *******************************************
    // *           useEffects                    *
    // *******************************************
    useEffect(function () {
        checkIfMFIsAccessible()
            .then(function (res) {
            if (!res) {
                topLevelTabs.splice(0, 1);
                seOrderbookTabs(topLevelTabs);
            }
            else {
                seOrderbookTabs(topLevelTabs);
            }
        })
            .catch(function () {
            topLevelTabs.splice(0, 1);
            seOrderbookTabs(topLevelTabs);
        });
    }, []);
    useEffect(function () {
        !!props.setHeaderLeftComponent &&
            props.setHeaderLeftComponent(React.createElement("div", { className: "d-flex align-items-center gap-4" }, generatePageHeaderName("Order Book")));
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { id: "orderbook-primary-portal-container" }),
        React.createElement(TopCurvedGenericTabs, { topLevelTabs: orderbookTabs, horizontalScroll: true, defaultActiveKey: (orderbookTabs === null || orderbookTabs === void 0 ? void 0 : orderbookTabs.length) ? orderbookTabs[0].eventKey : "" })));
};
export default RMOrderbook;
